<template>

    <form class="update-password__card " autocomplete="off">
        <div class="card-header">
            <h5 class="card-title">Update Password</h5>
            <hr>
        </div>
        <div class="card-body">
            <input id="password" style="display:none" type="password" name="fakepasswordremembered">
            <input id="password2" style="display:none" type="password" name="fakepassword2remembered">
            <input id="password3" style="display:none" type="password" name="fakepassword3remembered">
            <BasicTextInput class="mb-2" label="Current Password"
                            placeholder="Current Password"
                            type="password"
                            v-model="password.current" />
            <BasicTextInput class="mb-2" label="New Password"
                            placeholder="New Password"
                            :validator="$v.password.new"
                            :validatorMsgMap="passwordMsgMap"
                            v-model="password.new"
                            type="password" />
            <BasicTextInput class="mb-2" label="Confirm New Password"
                            placeholder="Confirm New Password"
                            :validator="$v.password.confirmNew"
                            :validatorMsgMap="passwordMsgMap"
                            v-model="password.confirmNew"
                            type="password" />
            <div class="d-flex justify-content-end">
                <div class="btn btn-primary" @click="updatePassword">Update Password</div>
            </div>
        </div>
    </form>
</template>

<script>
    import { UserService } from '@/services';

    import {
        required,
        minLength,
        helpers,
        sameAs,
    }                              from 'vuelidate/lib/validators';
    import { validatorMsgMapBase } from "@/modules/helpers";

    const hasDigit           = helpers.regex('hasDigit', /\d/);
    const hasUppercase       = helpers.regex('hasUppercase', /[A-Z]/);
    const hasLowercase       = helpers.regex('hasLowercase', /[a-z]/);
    const hasNonAlphanumeric = helpers.regex('hasNonAlphanumeric', /\W/);
    export default {
        name: "UpdatePassword",
        data: () => {
            return {
                validatorMsgMapBase: validatorMsgMapBase,
                password: {
                    current: '',
                    new: '',
                    confirmNew: '',
                }
            }
        },
        validations: {
            password: {
                new:    {
                    required,
                    minLength: minLength(8),
                    hasUppercase,
                    hasLowercase,
                    hasDigit,
                    hasNonAlphanumeric,
                },
                confirmNew:    {
                    required,
                    sameAsNew: sameAs('new')
                },
            }
        },
        computed: {
            passwordMsgMap(){
                return { ...this.validatorMsgMapBase,
                    sameAsNew: 'New Passwords must match',
                    minLength: 'Must be at least 8 Characters'};
            },
        },
        methods: {
            updatePassword(){
                this.$v.password.$touch();
                if (this.$v.password.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }
                let data = {
                    oldPassword: this.password.current,
                    newPassword: this.password.new,
                    confirmPassword: this.password.confirmNew,
                };

                UserService.updatePassword(data).then(res => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Password Updated', type: 'success'});
                    this.clearPasswordFields();
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error'});
                })
            },
            clearPasswordFields(){
                this.password.current    = '';
                this.password.new        = '';
                this.password.confirmNew = '';
                this.$v.password.$reset();
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
